<template>
  <div class="footer">
    <div class="message">
      <div class="qrCode">
        <img src="@/assets/img/erweima.png" alt>
      </div>
      <ul>
        <li>地址：福建省厦门市湖里区象屿路99号厦门国际航运中心E区</li>
        <li>邮编：361006</li>
        <li>电话：0592-2390232</li>
        <li>技术支持：云粮网（厦门）信息科技有限公司</li>
        <li>闽ICP备17002812号4</li>
        <li>闽公网安备：35021102000214号</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background-color: #f3f3f3;
  padding: 15px 0;
  margin-top: 30px;
}
.message {
  display: flex;
  justify-content: center;
  font-size: 14px;
  div {
    vertical-align: middle;
    width: 130px;
    height: 130px;
    img {
      vertical-align: middle;
      width: 100%;
      height: 100;
    }
  }
  ul {
    margin: 0;
    padding: 10px 0 0 30px;
    li {
      list-style: none;
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 980px) {
  .footer {
    width: 100%;
    min-width: 100%;
    background-color: #f3f3f3;
    padding: 10px 0;
    margin-top: 10px;
  }
  .qrCode {
    display: none;
  }
  .message {
    display: flex;
    justify-content: flex-start;
    font-size: 10px;
    padding: 0 10px;
    /*div {*/
    /*  display: block;*/
    /*  width: 100px;*/
    /*  height: 100px;*/
    /*  img {*/
    /*    width: 100%;*/
    /*    height: 100%;*/
    /*  }*/
    /*}*/
    ul {
      margin: 0;
      padding: 0;
      li {
        list-style: none;
      }
    }
  }
}
</style>

